import { isNil } from 'ramda';

type GridColCellAlignment = 'left' | 'right' | 'center' | undefined;
export type GridColCellAlignments =
  | GridColCellAlignment
  | Array<GridColCellAlignment>
  | ((colIndex: number) => GridColCellAlignment);

const getColCellAlignment = (colCellAlignments: GridColCellAlignments, colIndex: number): string => {
  if (isNil(colCellAlignments)) return DEFAULT_CELL_ALIGNMENT;

  if (typeof colCellAlignments === 'string') return colCellAlignments;
  if (typeof colCellAlignments === 'function') return getColCellAlignment(colCellAlignments(colIndex), colIndex);

  if (Array.isArray(colCellAlignments)) {
    const cellAlignment = colCellAlignments[colIndex];
    return getColCellAlignment(cellAlignment, colIndex);
  }

  throw new Error(`Attempted to get column alignment from an unsupported type. Value was "${colCellAlignments}".`);
};

export const DEFAULT_CELL_ALIGNMENT = 'center';
export default getColCellAlignment;
